'use strict';

export default {
  back: function (event) {
    event.preventDefault();
    window.history.back();
    return false;
  }
};
